import { clsx } from "clsx";
import DOMPurify, { Config as DOMPurifyConfig } from "dompurify";
import { forwardRef, Ref } from "react";

interface UnsafeHtmlProps {
  children?: string;
  className?: string;
  purifyOpts?: DOMPurifyConfig;
  color?: "white";
}

function UnsafeHtmlInner(
  { children, className, purifyOpts, color, ...restProps }: UnsafeHtmlProps,
  ref: Ref<HTMLDivElement>
) {
  if (!children) {
    return null;
  }

  const unsafeContent = {
    __html: purifyOpts
      ? DOMPurify.sanitize(children, {
          ...purifyOpts,
          RETURN_DOM: false,
          RETURN_DOM_FRAGMENT: false,
        })
      : DOMPurify.sanitize(children),
  };

  return (
    <div
      ref={ref}
      dangerouslySetInnerHTML={unsafeContent}
      className={clsx(
        className,
        "vst-pretty-html",
        color && `vst-pretty-html-variant-${color}`
      )}
      {...restProps}
    />
  );
}

export const UnsafeHtml = forwardRef(UnsafeHtmlInner);
